import AddIcon from '@mui/icons-material/Add'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import SearchIcon from '@mui/icons-material/Search'
import { IconButton, TextField, Toolbar } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoanListFiltersDialog from './LoanListFiltersDialog'

const LoanListOptions = () => {
  const { t } = useTranslation()

  const [searchValue, setSearchValue] = useState<string>('')
  const [openFilterDialog, setopenFilterDialog] = useState<boolean>(false)

  const handleOnSearchFieldChange = (value: string) => {
    setSearchValue(value)
  }

  const handleOnSearchButtonClicked = () => {
    // TODO: Implement search functionality
  }

  return (
    <>
      <Toolbar disableGutters>
        <TextField
          label={t('common.search')}
          onChange={(e) => handleOnSearchFieldChange(e.target.value)}
          defaultValue={searchValue}
          fullWidth
        />
        <IconButton href="/loans/create" size="large">
          <AddIcon fontSize="inherit" />
        </IconButton>
        <IconButton size="large" onClick={handleOnSearchButtonClicked}>
          <SearchIcon />
        </IconButton>
        <IconButton size="large" onClick={() => setopenFilterDialog(true)}>
          <FilterAltIcon />
        </IconButton>
      </Toolbar>
      <LoanListFiltersDialog open={openFilterDialog} onClose={() => setopenFilterDialog(false)} onSubmit={() => {}} />
    </>
  )
}

export default LoanListOptions
